import { API_HELPER } from '@/helpers/api.js';
import { authHeader } from '@/helpers/auth-header.js';

const AVAILABILITY_INTERVALS_API = 'AvailabilityIntervals';

export const availabilityIntervalsService = {
  getList(input) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, input, requestOptions);
  },
  
  getById(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API, id]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  create(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API]);
    
    // Format data for API
    const formattedData = {
      ...data,
      startDate: data.startDate instanceof Date ? data.startDate.toISOString().split('T')[0] : data.startDate,
      endDate: data.endDate instanceof Date ? data.endDate.toISOString().split('T')[0] : data.endDate,
      startTime: data.startTime.includes(':') ? data.startTime : data.startTime + ':00'
    };
    
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(formattedData)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  update(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API]);
    
    // Format data for API
    const formattedData = {
      ...data,
      startDate: data.startDate instanceof Date ? data.startDate.toISOString().split('T')[0] : data.startDate,
      endDate: data.endDate instanceof Date ? data.endDate.toISOString().split('T')[0] : data.endDate,
      startTime: data.startTime.includes(':') ? data.startTime : data.startTime + ':00'
    };
    
    const requestOptions = {
      method: 'PUT',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(formattedData)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  delete(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API, id]);
    const requestOptions = {
      method: 'DELETE',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  generateSlots(id, regenerateExisting = false) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API, id, 'generate-slots']);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, { regenerateExisting }, requestOptions);
  },
  
  archive(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API, id, 'archive']);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  unarchive(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, AVAILABILITY_INTERVALS_API, id, 'unarchive']);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  }
};

